export default (state, action) => ({ ...state, processBuilderValidationErrors: action.payload.errors })
